import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import axios from "axios";
import "../management/ManagementModal.scss";
import { errorToast, successToast } from "../../common/ToastMessage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function AddEditBrand({ openBrand, close, getBrands, isAdd, brandID, brandData, setLoaderActive }) {
    const [brandName, setBrandName] = React.useState("");
    const [error, setError] = React.useState([]);
    const headers = {
        Authorization: "Bearer " + localStorage.getItem("_token"),
        "Content-type": "application/json",
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!isAdd) {
            setBrandName(brandData?.brandName)
        } else {
            setBrandName("")
        }
    }, [brandData]);

    const saveBrand = async () => {
        if (validateForm()) {
            if (isAdd) {
                let item = { brandName: brandName }
                addEditBrandName(item, 'InsertBrandName')
            } else {
                let item = { Brandid: brandID, BrandName: brandName }
                addEditBrandName(item, 'UpdateBrandDetail')
            }
        }
    }
    const addEditBrandName = (payload, url) => {
        setLoaderActive(true);
        axios.post(`${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/${url}`, payload,
            {
                headers: headers,
            })
            .then(function (response) {
                console.log("response add update-", response);
                if (response?.status == '200') {
                    if (response?.data?.message == 'Brand Name Already Exist') {
                        setError({ ...error, brandName: response?.data?.message })
                        errorToast(response?.data?.message)
                        setLoaderActive(false);
                    } else {
                        close();
                        successToast(response?.data?.message)
                        getBrands()
                    }
                }
            })
            .catch(function (error) {
                console.log('error', error);
                setLoaderActive(false);
                if (error?.response?.status === 401) {
                    errorToast(error?.response?.statusText)
                } else {
                    errorToast(error?.message)
                }
            });
    }

    const validateForm = () => {
        setError([]);
        let error = {}
        if (!brandName) {
            error.brandName = "Brand Name is required."
        }
        if (Object.keys(error).length > 0) {
            setError(error);
            return false;
        }
        return true;
    }

    return (
        <div>
            <BootstrapDialog
                className="management-modal-wrap modal-wrap"
                aria-labelledby="customized-dialog-title"
                open={openBrand}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => { setError([]); setBrandName(''); close() }}
                >
                    {isAdd ? 'Add' : 'Edit'} Brand
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="txtfield-wrap">
                                <TextField
                                    error={error && error.brandName}
                                    id="outlined-required"
                                    fullWidth
                                    label="Brand Name"
                                    value={brandName}
                                    onChange={(e) => setBrandName(e.target.value)}
                                    helperText={error.brandName}
                                />
                            </div>
                            <div className="txtfield-wrap">
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="btns-wrapper btn-padding" style={{ padding: '10px ' }}>
                    <Stack spacing={4} direction="row" className="bottom-btn-wrap">
                        <Button onClick={() => { saveBrand() }} variant="outlined">{isAdd ? 'Save' : 'Update'}</Button>
                        <Button variant="outlined" onClick={() => { setError([]); setBrandName(''); close() }}>Cancel</Button>
                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
